import { Wrapper } from "@Src/layout/Wrapper";
import { ApplicationsList } from "@Src/resources/applications/ApplicationsList";
import { ApplicationsShow } from "@Src/resources/applications/ApplicationsShow";
import { resourceName } from "@Src/resources/applications/name";
import type { Resource } from "@Src/resources/resources_config";
import FolderIcon from "@mui/icons-material/Folder";

const resource: Resource = {
	list: Wrapper(resourceName.name, "list", ApplicationsList),
	show: Wrapper(resourceName.name, "show", ApplicationsShow),
	icon: FolderIcon,
	name: resourceName.name,
	path: `/${resourceName.name}`,
	apiPath: "applications/applications",
	options: {
		label: "Responses",
	},
};

export default resource;
